import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useResetStore } from '~/composables/common/use-reset-store'
import { useResetCookie } from '~/composables/common/use-reset-cookie'

export function useSyncAuthenticateDataTab() {
  const resetStore = useResetStore()
  const router = useRouter()
  const { resetCookie } = useResetCookie()
  onMounted(() => {
    window.addEventListener('storage', event => {
      if (event.key === 'userData') {
        const oldValue = event.oldValue ? JSON.parse(event.oldValue ?? '') : ''
        const newValue = event.newValue ? JSON.parse(event.newValue ?? '') : ''
        if (!oldValue?.data?.token && newValue?.data.token) {
          if (sessionStorage.getItem('isLogged')) {
            sessionStorage.removeItem('isLogged')
          } else {
            const RELOAD_TIMEOUT = 500
            setTimeout(() => {
              window.location.reload()
            }, RELOAD_TIMEOUT)
          }
        } else if (oldValue?.data?.token && !newValue?.data.token) {
          resetCookie()
          resetStore.all()
          void router.push('/')
        }
      }
    })
  })
  onUnmounted(() => {
    window.removeEventListener('storage', () => {})
  })

  return {}
}
